import React from 'react';

// Simple CSS-based line chart component
const LineChart = ({ data, height = '200px', color = '#3B82F6', labelKey = '_id', valueKey = 'count', showArea = false }) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center" style={{ height }}>
        <p className="text-gray-500">No data available</p>
      </div>
    );
  }

  const maxValue = Math.max(...data.map(item => item[valueKey] || 0));
  const minValue = Math.min(...data.map(item => item[valueKey] || 0));
  const range = maxValue - minValue || 1;
  
  const points = data.map((item, index) => {
    const value = item[valueKey] || 0;
    const x = (index / (data.length - 1)) * 100;
    const y = 100 - (((value - minValue) / range) * 90) - 5; // Leave 5% margin
    return { x, y, value, label: item[labelKey] };
  });

  const pathData = points.map((point, index) => 
    `${index === 0 ? 'M' : 'L'} ${point.x} ${point.y}`
  ).join(' ');

  const areaPathData = [
    `M ${points[0].x} 95`,
    ...points.map(p => `L ${p.x} ${p.y}`),
    `L ${points[points.length - 1].x} 95`,
    'Z'
  ].join(' ');

  return (
    <div style={{ height, position: 'relative' }}>
      <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="w-full h-full">
        {/* Grid lines */}
        <defs>
          <linearGradient id={`gradient-${color}`} x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor={color} stopOpacity="0.3" />
            <stop offset="100%" stopColor={color} stopOpacity="0.05" />
          </linearGradient>
        </defs>
        
        {/* Area under line */}
        {showArea && (
          <path
            d={areaPathData}
            fill={`url(#gradient-${color})`}
            className="opacity-50"
          />
        )}
        
        {/* Line */}
        <path
          d={pathData}
          fill="none"
          stroke={color}
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        
        {/* Points */}
        {points.map((point, index) => (
          <circle
            key={index}
            cx={point.x}
            cy={point.y}
            r="0.8"
            fill={color}
            className="hover:r-1.2 transition-all"
            title={`${point.label}: ${point.value}`}
          />
        ))}
      </svg>
      
      {/* X-axis labels */}
      <div className="absolute bottom-0 left-0 right-0 flex justify-between text-xs text-gray-500 px-1">
        {data.map((item, index) => {
          const label = typeof item[labelKey] === 'string' && item[labelKey].includes('-') 
            ? item[labelKey].split('-')[2] 
            : item[labelKey];
          return (
            <span key={index} className="truncate" style={{ flex: 1, textAlign: index === 0 ? 'left' : index === data.length - 1 ? 'right' : 'center' }}>
              {index % Math.ceil(data.length / 5) === 0 || index === data.length - 1 ? label : ''}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default LineChart;

